import { TCustomerAccountInformationPayload } from "@zeal/common";
import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";

export const validateCustomerAccountShareableLinkToken = (
  axios: IAxiosInstance
) => {
  return async (body: { accessToken: string }) => {
    const response = await axios.noRetry.post<{
      data: TCustomerAccountInformationPayload;
    }>("/api/validateCustomerAccountShareableLinkToken", body);
    return response.data.data;
  };
};
